import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";

const apiService = new ApiService();

const buildQuery = (page, size, search) => {
  const params = new URLSearchParams({ page: String(page), size: String(size) });
  if (search && search.trim()) params.append('search', search.trim());
  return params.toString();
};

export const listMobileAgents = async (page = 0, size = 20, search = '') => {
  try {
    const response = await apiService.get(`${apiEndPoints.mobileUsersAgents}?${buildQuery(page, size, search)}`);
    return { statusCode: 200, data: response.data };
  } catch (error) {
    return { statusCode: error?.response?.status || 500, message: error?.response?.data?.message || 'Failed to load agents' };
  }
};

export const listMobileFarmers = async (page = 0, size = 20, search = '') => {
  try {
    const response = await apiService.get(`${apiEndPoints.mobileUsersFarmers}?${buildQuery(page, size, search)}`);
    return { statusCode: 200, data: response.data };
  } catch (error) {
    return { statusCode: error?.response?.status || 500, message: error?.response?.data?.message || 'Failed to load farmers' };
  }
};

// The per-row "send mobile OTP code" action reuses the existing endpoint.
export { mobileLoginCodeApi } from '../user/user.service';
